import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { ManufacturerInterface, ReportManufacturerInterface } from 'src/app/util/interfaces/manufacturer';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class ManufacturerService {
	private postManufacturerURL = environment.baseApiUrl + 'manufacturer/createManufacturer';
	private updateManufacturerURL = environment.baseApiUrl + 'manufacturer/updateManufacturer/{id}';
	private searchManufacturerURL = environment.baseApiUrl + 'manufacturer/searchManufacturer';
	private deleteManufacturersURL = environment.baseApiUrl + 'manufacturer/inactiveManufacturers';
	private activeManufacturersURL = environment.baseApiUrl + 'manufacturer/activeManufacturers';
	private getReportManufacturerURL = environment.baseApiUrl + 'manufacturer/reportManufacturer';

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getAllManufacturers(): Observable<ManufacturerInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.httpClient.get<any[]>(this.searchManufacturerURL, { headers: headers }).pipe(
			map((manufacturerArray: ManufacturerInterface[]) => {
				for (const manufacturer of manufacturerArray) {
					manufacturer['icon'] = manufacturer.version == 'Manualmente' ? 'faPencil' : 'faLock';
				}

				return manufacturerArray;
			})
		);
	}

	getManufacturerById(id: string): Observable<ManufacturerInterface> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const searchManufacturerURL = this.searchManufacturerURL + '?id=' + id;

		return this.httpClient.get<any>(searchManufacturerURL, { headers: headers }).pipe(
			map((manufacturerReceived) => {
				manufacturerReceived = manufacturerReceived[0];
				const newManufacturer: ManufacturerInterface = {
					id: manufacturerReceived.id,
					manufacturer: manufacturerReceived.manufacturer,
					active: manufacturerReceived.active,
					version: manufacturerReceived.version,
					customer: manufacturerReceived.customer,
					message: manufacturerReceived.message,
				};
				return newManufacturer;
			}),
			catchError((error) => {
				throw error;
			})
		);
	}

	postManufacturer(form: ManufacturerInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			manufacturer: form.manufacturer,
			active: form.active,
			version: form.version,
			customer: form.customer,
			message: form.message,
		};
		return this.httpClient.post(this.postManufacturerURL, body, { headers: headers });
	}

	updateManufacturer(formUpdate: ManufacturerInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		const updateManufacturerURL = this.updateManufacturerURL.replace('{id}', formUpdate.id);
		const body = {
			manufacturer: formUpdate.manufacturer,
			active: formUpdate.active,
			version: formUpdate.version,
			customer: formUpdate.customer,
			message: formUpdate.message,
		};
		return this.httpClient.put(updateManufacturerURL, body, { headers: headers });
	}

	deleteManufacturer(manufacturerIds: number[], message: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const deleteManufacturerURL = this.deleteManufacturersURL;
		const requestBody = { ids: manufacturerIds, message: message };

		return this.httpClient.put<any>(deleteManufacturerURL, requestBody, { headers: headers });
	}

	activeManufacturer(manufacturerIds: number[], message: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const activeManufacturerURL = this.activeManufacturersURL;
		const requestBody = { ids: manufacturerIds, message: message };

		return this.httpClient.put<any>(activeManufacturerURL, requestBody, { headers: headers });
	}

	getReportManufacturer(id: number): Observable<ReportManufacturerInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		const getReportManufacturerURL = this.getReportManufacturerURL + '?id_manufacturer=' + id;
		return this.httpClient.get<ReportManufacturerInterface[]>(getReportManufacturerURL, {
			headers: headers,
		});
	}
}
